'use strict';

import React from 'react';

import Title from "../../components/Title/Title";
import Wizard from "../../components/Wizard/Wizard";
import { OnSchedUtils } from "../../utils";
import { GetLocation } from '../../actions/locationActions';


const Location = element => {
  const [state, setState] = React.useState({});

  React.useEffect(() => {
    GetLocation(element, element.params).then(location => setState({location}))
  }, [])
  
  // React.useEffect(() => 
  //   console.log('state', state), [state]
  // )
  
  return (
    <>
      <Title element={element} title={OnSchedUtils.Internationalize(element, 'location_title')}/>
      <Wizard onSubmit={null} element={element} onschedState={{state, setState}} form="LocationForm" />
    </>
  )
}

export default Location;
